import _ from "lodash"

export const isAdminOrSubadmin = props => {
  let { roleName, roleId, roles } = props

  if( roleName?.toLowerCase().indexOf( 'admin' ) > -1 ) {
    return true
  } else if( _.find( roles, { id: roleId })?.name?.toLowerCase().indexOf( 'admin' ) > -1 ) {
    return true
  } else {
    return false
  }
}

export const isAdmin = props => {
  let { roleName, roleId, roles } = props

  if( roleName === 'Master Admin' || roleName === 'Admin' ) {
    return true
  } else if( _.find( roles, { id: roleId })?.name === 'Master Admin' || _.find( roles, { id: roleId })?.name === 'Admin' ) {
    return true
  } else {
    return false
  }
}

export const isSubadmin = props => {
  let { roleName, roleId, roles } = props

  if( roleName?.toLowerCase().indexOf( 'subadmin' ) > -1 ) {
    return true
  } else if( _.find( roles, { id: roleId })?.name?.toLowerCase().indexOf( 'subadmin' ) > -1 ) {
    return true
  } else {
    return false
  }
}

export const isReservedMember = props => {
  let { username } = props
  const REESERVED_USERNAMES = [
    'member001', 'member002', 'member003',
    'member004', 'member005', 'member006',
    'member007'
  ]

  if (REESERVED_USERNAMES.includes(username)) {
    return true
  } else {
    return false
  }
}
